import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.css';

const App = () => (
  <div>
    {/* The actual content is rendered from public/index.html for now. */}
    <h1>Basith Rahman | Professional Portfolio</h1>
    <p>Welcome to my professional website. Please use the navigation above to explore my work and skills.</p>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
